'use client';
import { useTranslations } from 'next-intl';
import { Selector } from '../../../../../SelectorGroup/index';
import { usePrizeTablesContext, type TableData } from '../../context';
import { getTableSwitcherTrackingName } from './getTableSwitcherTrackingName';

type TablesSwitcherProps = {
  selectedId: string;
  setSelectedTable: (table: TableData) => void;
};

/**
 * TablesSwitcher component renders set of control buttons for switching between different lottery tables.
 * Is expected to be used withing Powerball lottery (and legacy MegaMillions).
 *
 * @param selectedId - Currently selected table ID (from parent component).
 * @param setSelectedTable - Function to change the selected table.
 * @returns Rendered TablesSwitcher component.
 */
function TablesSwitcher({ selectedId, setSelectedTable }: TablesSwitcherProps) {
  const { tables, namespace } = usePrizeTablesContext();
  const t = useTranslations(namespace);

  return (
    <div className="flex gap-1" data-track-container="Filters">
      {tables.map(table => {
        const tableSwitcherName = t(`table_switcher.${table.lotteryId}`);
        const tableSwitcherTrackingName = getTableSwitcherTrackingName(table.lotteryId) ?? tableSwitcherName;

        return (
          <Selector
            key={table.lotteryId}
            value={table.lotteryId}
            selected={selectedId === table.lotteryId}
            onClick={() => setSelectedTable(table)}
            className="flex justify-center paragraph-explanatory-strong text-center"
            data-track-name={tableSwitcherTrackingName}
          >
            {tableSwitcherName}
          </Selector>
        );
      })}
    </div>
  );
}

export { TablesSwitcher };
